import React, { useEffect, useMemo, useState } from 'react';
import DataTable from '../../../components/DataTable';
import PageHeaderActions from '../../../components/General/PageHeaderActions';
import { useRowSpan } from '../../../components/DataTable/useRowSpan';
import { getAllCandidateForSaDashboard } from '../../../api/SubmissionsAPI';
import moment from 'moment';
import { Card } from 'react-bootstrap';
import { handleApiError } from '../../../common/errorHandler';
import { useSearchParams } from 'react-router-dom';

function AadharCandidates({
  className = '',
  selectedExam,
  selectedExamDay,
  examDays,
  isNodal,
  rrb,
  noddle_selected_rrb_id,
  selectedDate,
  dataTableCardClass = '',
}) {
  const [totalRecords, setTotalRecords] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [allAadharCandidates, setAllAadharCandidates] = useState({});
  const [nodalSelectedDate, setNodalSelectedDate] = useState(
    selectedDate || ''
  );
  const [nodalSelectedExam, setNodalSelectedExam] = useState(
    selectedExam || ''
  );
  const [noddleSelectedRrbId, setNoddleSelectedRrbId] = useState(
    selectedExam?.value || ''
  );

  useEffect(() => {
    setNoddleSelectedRrbId((prev) => selectedExam?.value || prev);
    setNodalSelectedExam((prev) => selectedExam || prev);
    setNodalSelectedDate((prev) => selectedDate || prev);
  }, [selectedExam, selectedDate]);

  useEffect(() => {
    setFilter((prev) => ({
      ...prev,
      exam_date: moment(
        selectedDate ? selectedDate?.value : prev.exam_date
      ).format('YYYY-MM-DD'),
      ministryExamId: selectedExam?.value || prev.ministryExamId,
      noddle_selected_rrb_id: noddle_selected_rrb_id?.value, // Added to ensure noddle_selected_rrb_id is included
    }));
  }, [selectedExam, selectedDate, noddle_selected_rrb_id]);

  const [filter, setFilter] = useState({
    _page: 1,
    _limit: 25,
    q: '',
    _sort: 'center.rrb_id',
    _order: 'asc',
    isDelete: null,
    exam_date: nodalSelectedDate ? nodalSelectedDate?.value : '',
    ministryExamId: nodalSelectedExam?.value ? nodalSelectedExam.value : '',
    rrb: rrb ? rrb : '',
    noddle_selected_rrb_id: '',
    isNodal: isNodal ? isNodal : false,
    super_rrb_id: null,
  });

  const [searchParams] = useSearchParams();
  const rrb_id = searchParams.get('id');

  useEffect(() => {
    if (
      rrb_id &&
      rrb_id.length > 0 &&
      rrb_id !== undefined &&
      rrb_id !== null &&
      rrb_id !== 'null' &&
      rrb_id !== 'undefined'
    ) {
      setFilter((prev) => ({
        ...prev,
        super_rrb_id: rrb_id,
      }));
    }
  }, []);

  useEffect(() => {
    setFilter((prev) => {
      return {
        ...prev,
        exam_date: selectedExamDay?.value
          ? moment(selectedExamDay?.value).format('YYYY-MM-DD')
          : '',
        ministryExamId: selectedExam?.value || '',
      };
    });
  }, [selectedExam, selectedExamDay]);

  const initialState = {
    sortBy: [{ id: 'center.rrb_id', desc: false }],
    pageSize: filter._limit,
    pageIndex: 0,
  };
  const getAllAadharCandidates = async () => {
    setIsLoading(true);

    try {
      const res = await getAllCandidateForSaDashboard(filter);

      if (res?.data) {
        setAllAadharCandidates(res.data.results || []);
        setTotalRecords(res?.data?.totalRecords || 0);
      } else {
        setAllAadharCandidates([]);
        setTotalRecords(0);
      }
    } catch (error) {
      console.error('Error fetching candidates:', error);
      setAllAadharCandidates([]);
      setTotalRecords(0);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    getAllAadharCandidates();
  }, [filter]);

  const columns = useMemo(
    () => [
      {
        Header: () => (
          <div style={{ whiteSpace: 'normal', textAlign: 'start' }}>RRB</div>
        ),
        className: 'rounded-3',
        accessor: 'rrb_name',
        enableRowSpan: true,
        disableSortBy: true,
      },
      {
        Header: () => (
          <div style={{ whiteSpace: 'normal', textAlign: 'start' }}>Center</div>
        ),
        accessor: 'center',
        enableRowSpan: true,
        disableSortBy: true,
      },
      {
        Header: () => (
          <div style={{ whiteSpace: 'normal', textAlign: 'center' }}>Shift</div>
        ),
        accessor: 'shift',
        disableSortBy: true,
        width: '50',
        Cell: ({ value }) => (
          <span
            style={{
              display: 'block',
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              minWidth: '50px',
              maxWidth: '50px',
              textAlign: 'center',
            }}
          >
            {value}
          </span>
        ),
      },
      {
        Header: () => (
          <div style={{ whiteSpace: 'normal', textAlign: 'center' }}>
            Scheduled
          </div>
        ),
        accessor: 'scheduled',
        disableSortBy: true,
        width: '80',
        Cell: ({ value }) => (
          <span
            style={{
              display: 'block',
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              minWidth: '80px',
              maxWidth: '80px',
              textAlign: 'center',
            }}
          >
            {value}
          </span>
        ),
      },
      {
        Header: () => (
          <div style={{ whiteSpace: 'normal', textAlign: 'center' }}>
            Appeared
          </div>
        ),
        accessor: 'present',
        disableSortBy: true,
        width: '80',
        Cell: ({ value }) => (
          <span
            style={{
              display: 'block',
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              minWidth: '80px',
              maxWidth: '80px',
              textAlign: 'center',
            }}
          >
            {value}
          </span>
        ),
      },
      {
        Header: () => (
          <div style={{ whiteSpace: 'normal', textAlign: 'center' }}>
            % Attendance
          </div>
        ),
        accessor: 'attendance_percentage',
        disableSortBy: true,
        width: '80',
        Cell: ({ row }) => {
          const { scheduled, present } = row.original;

          // Validate values to prevent errors
          const validScheduled = typeof scheduled === 'number' && scheduled > 0;
          const validPresent = typeof present === 'number' && present >= 0;

          // Calculate percentage only if valid values exist
          let attendancePercentage = 'N/A';
          if (validScheduled && validPresent) {
            const percentage = (present / scheduled) * 100;
            attendancePercentage = percentage.toFixed(2) + '%';
          }

          return (
            <span
              style={{
                display: 'block',
                whiteSpace: 'normal',
                wordWrap: 'break-word',
                minWidth: '80px',
                maxWidth: '80px',
                textAlign: 'center',

                color:
                  validScheduled &&
                  validPresent &&
                  (present / scheduled) * 100 < 50
                    ? 'red'
                    : 'inherit',
              }}
            >
              {attendancePercentage}
            </span>
          );
        },
      },
      {
        Header: () => (
          <div style={{ whiteSpace: 'normal', textAlign: 'center' }}>
            Biometric Registered
          </div>
        ),
        accessor: 'biometric_registered',
        disableSortBy: true,
        width: '80',
        Cell: ({ value }) => (
          <span
            style={{
              display: 'block',
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              minWidth: '80px',
              maxWidth: '80px',
              textAlign: 'center',
            }}
          >
            {value}
          </span>
        ),
      },
      {
        Header: () => (
          <div style={{ whiteSpace: 'normal', textAlign: 'center' }}>
            % Biometric Registered
          </div>
        ),
        accessor: 'biometric_registered_no',
        disableSortBy: true,
        width: '80',
        Cell: ({ row }) => {
          const { biometric_registered, present } = row.original;

          // Validate values to prevent errors
          const validPresent = typeof present === 'number' && present > 0;
          const validBiometric =
            typeof biometric_registered === 'number' &&
            biometric_registered >= 0;

          // Calculate percentage only if valid values exist
          let biometricPercentage = 'N/A';
          if (validPresent && validBiometric) {
            const percentage = (biometric_registered / present) * 100;
            biometricPercentage = percentage.toFixed(2) + '%';
          }

          return (
            <span
              style={{
                display: 'block',
                whiteSpace: 'normal',
                wordWrap: 'break-word',
                minWidth: '80px',
                maxWidth: '80px',

                textAlign: 'center',

                color:
                  validPresent &&
                  validBiometric &&
                  (biometric_registered / present) * 100 < 50
                    ? 'red'
                    : 'inherit',
              }}
            >
              {biometricPercentage}
            </span>
          );
        },
      },
      {
        Header: () => (
          <div style={{ whiteSpace: 'normal', textAlign: 'center' }}>
            Aadhar Registered
          </div>
        ),
        accessor: 'aadhaar_reg',
        disableSortBy: true,
        width: '80',
        Cell: ({ value }) => (
          <span
            style={{
              display: 'block',
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              minWidth: '80px',
              maxWidth: '80px',

              textAlign: 'center',
            }}
          >
            {value}
          </span>
        ),
      },
      {
        Header: () => (
          <div style={{ whiteSpace: 'normal', textAlign: 'center' }}>
            Aadhar Bypass
          </div>
        ),
        accessor: 'total_aadhar_bypass',
        disableSortBy: true,
        width: '80',
        Cell: ({ value }) => (
          <span
            style={{
              display: 'block',
              whiteSpace: 'normal',
              wordWrap: 'break-word',

              minWidth: '80px',
              maxWidth: '80px',

              textAlign: 'center',
            }}
          >
            {value}
          </span>
        ),
      },
      {
        Header: () => (
          <div style={{ whiteSpace: 'normal', textAlign: 'center' }}>
            % Aadhaar Registered
          </div>
        ),
        className: 'rounded-3',
        accessor: 'aadhar_reg',
        disableSortBy: true,
        width: '80',
        Cell: ({ row }) => {
          const { aadhaar_reg, present } = row.original;

          // Ensure both values are valid numbers
          let percentage = 'N/A';
          if (
            typeof aadhaar_reg === 'number' &&
            typeof present === 'number' &&
            present > 0
          ) {
            percentage = ((aadhaar_reg / present) * 100).toFixed(2);
          }

          return (
            <span
              style={{
                display: 'block',
                whiteSpace: 'normal',
                wordWrap: 'break-word',
                minWidth: '80px',
                maxWidth: '80px',

                textAlign: 'center',
                color:
                  percentage !== 'N/A' && percentage < 50 ? 'red' : 'inherit', // Red if below 50%
              }}
            >
              {percentage !== 'N/A' ? `${percentage}%` : percentage}
            </span>
          );
        },
      },
    ],
    []
  );

  const defaultOption = (() => {
    const matchedExam = examDays?.find(
      ({ date }) =>
        moment(date).format('DD/MM/YYYY') === moment().format('DD/MM/YYYY')
    );

    return matchedExam
      ? {
          key: moment(matchedExam.date).format('YYYY-MM-DD'),
          label: moment(matchedExam.date).format('DD/MM/YYYY'),
        }
      : { key: null, label: moment().format('DD/MM/YYYY') };
  })();

  return (
    <div className={className}>
      <DataTable
        header={
          !isNodal && (
            <Card.Header className='bg-light-rrb'>
              <h3 className='fs-16 mb-0 fw-medium'>Shift Wise Attendance</h3>
            </Card.Header>
          )
        }
        cardClass={dataTableCardClass}
        columns={columns}
        data={allAadharCandidates.length > 0 ? allAadharCandidates : []}
        initialState={initialState}
        totalRecords={totalRecords}
        setFilter={setFilter}
        tableHooks={(hooks) => {
          hooks.useInstance.push(useRowSpan);
        }}
        defaultPageLength={[25, 50, 100]}
        isLoading={isLoading}
        manual={true}
        align='table-vcenter'
        enableRowSpan
        placeholder='Type to search'
        hideSearch={isNodal}
        {...(!isNodal && {
          extraSelectFilter: true,
          extraSelectOptions: examDays
            ? examDays.map(({ id, date }) => ({
                id,
                date,
                key: moment(date).format('YYYY-MM-DD'),
                label: moment(date).format('DD/MM/YYYY'),
              }))
            : [],
          defaultOption: examDays?.some(({ date }) =>
            moment(date).isSame(moment(), 'day')
          )
            ? {
                key: moment().format('YYYY-MM-DD'),
                label: moment().format('DD/MM/YYYY'),
              }
            : {
                key: '',
                label: 'Select Exam Date',
              },
          setSelectState: (date) => {
            setIsLoading(true);
            setFilter((prev) => ({
              ...prev,
              exam_date: date,
            }));
          },
        })}
      />
    </div>
  );
}

export default AadharCandidates;
